<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>

            <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Cadastro Usuário</v-toolbar-title>
                <v-spacer/>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
                <template v-slot:extension>
                    <v-tabs v-model="tabActive" color="secondary">
                        <v-tab>Geral</v-tab>
                        <v-tab>Permissões</v-tab>
                    </v-tabs>
                </template>
            </v-toolbar>

            <v-card-text class="mt-5">

                <v-tabs-items v-model="tabActive">
                    <v-tab-item>
                        <v-row>
                            <v-col cols="12" sm="12" md="4" lg="3" align-self="center">
                                <center>
                                    <v-card height="250" min-width="300" max-width="300" class="mb-5">
                                        <v-row>
                                            <v-col class="mx-2">
                                                <v-skeleton-loader v-bind="attrs = {boilerplate: true}" max-width="300" max-height="150" type="image" v-if="!item.foto"/>
                                                <v-img v-if="item.foto" contain :src="`data:image/jpeg;base64,${item.foto}`" style="max-height: 160px ; max-width: 275px"></v-img>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col class="ma-2">
                                            <div>
                                                <div v-if="!item.foto" >
                                                    <v-file-input prepend-icon="mdi-camera" accept="image/png, image/jpeg" show-size label="Foto" v-model="foto" outlined dense @change="LoadImage()"/>
                                                </div>
                                                <div class="text-right" v-else>
                                                    <v-btn icon @click="RemoveImage()"><v-icon>mdi-close</v-icon></v-btn>                    
                                                </div>
                                            </div>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </center>
                            </v-col>
                            <v-col cols="12" sm="12" md="8" lg="9">
                                <v-form id="form" ref="form" v-model="valid" lazy-validation >
                                    <v-row>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="item.nome" label="Nome" :rules="fieldRules" :counter="10" maxlength="10" dense outlined/>
                                        </v-col>                        
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field type="password" v-model="item.senha" label="Senha" :readonly="item.id != 0" :rules="fieldRules" :counter="50" maxlength="50" dense outlined/>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="item.email" label="Email" :rules="fieldRules" :counter="150" maxlength="150" dense outlined/>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-select v-model="item.pessoalId" label="Recurso Pessoal" :items="recursos" item-value="id" item-text="nome" dense outlined/>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-col>
                        </v-row>
                    </v-tab-item>

                    <v-tab-item>

                        <v-row>
                            <v-col cols="12" md="6" sm="6">
                                <fieldset class="pa-4">
                                    <legend>Projetos</legend>
                                        <v-list dense>
                                            <div v-for="(projeto, index) in projetos" :key="index">
                                                <!-- <v-list-item :class="[{'itemActive': projeto.selected }, 'itemNeutral']"> -->
                                                <v-list-item>
                                                    <v-list-item-action>
                                                        <v-checkbox v-model="projeto.selected" @change="onChangeItem(projeto)" :disabled="projeto.restrito"></v-checkbox>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        {{projeto.nome}}
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </div>
                                        </v-list>
                                </fieldset>
                            </v-col>
                            <v-col cols="12" md="6" sm="6">
                                <fieldset class="pa-4">
                                    <legend>Doação</legend>
                                        <v-list dense>
                                            <div v-for="(doacao, index) in doacoes" :key="index">
                                                <!-- <v-list-item :class="[{'blue lighten-5': doacao.selected }, 'selectItem']"> -->
                                                <v-list-item>
                                                    <v-list-item-action>
                                                        <v-checkbox v-model="doacao.selected" @change="onChangeItem(doacao)" :disabled="doacao.restrito"></v-checkbox>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        {{doacao.nome}}
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </div>
                                        </v-list>
                                </fieldset>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="6" sm="6">
                                <fieldset class="pa-4">
                                    <legend>Contas à Pagar</legend>
                                        <v-list dense>
                                            <div v-for="(contaP, index) in contasPagar" :key="index">
                                                <!-- <v-list-item :class="[{'blue lighten-5': contaP.selected }, 'white']"> -->
                                                <v-list-item>
                                                    <v-list-item-action>
                                                        <v-checkbox v-model="contaP.selected" @change="onChangeItem(contaP)" :disabled="contaP.restrito"></v-checkbox>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        {{contaP.nome}}
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </div>
                                        </v-list>
                                </fieldset>
                            </v-col>
                            <v-col cols="12" md="6" sm="6">
                                <fieldset class="pa-4">
                                    <legend>Contas à Receber</legend>
                                    <v-list dense>
                                        <div v-for="(contaR, index) in contasReceber" :key="index">
                                            <!-- <v-list-item :class="[{'blue lighten-5': contaR.selected }, 'white']"> -->
                                            <v-list-item>
                                                <v-list-item-action>
                                                    <v-checkbox v-model="contaR.selected" @change="onChangeItem(contaR)" :disabled="contaR.restrito"></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    {{contaR.nome}}
                                                </v-list-item-content>
                                            </v-list-item>
                                        </div>
                                    </v-list>
                                </fieldset>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="6" sm="6">
                                <fieldset class="pa-4">
                                    <legend>Tesouraria</legend>
                                    <v-list dense>
                                        <div v-for="(tesouraria, index) in tesourarias" :key="index">
                                            <!-- <v-list-item :class="[{'blue lighten-5': tesouraria.selected }, 'white']"> -->
                                            <v-list-item>
                                                <v-list-item-action>
                                                    <v-checkbox v-model="tesouraria.selected" @change="onChangeItem(tesouraria)" :disabled="tesouraria.restrito"></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    {{tesouraria.nome}}
                                                </v-list-item-content>
                                            </v-list-item>
                                        </div>
                                    </v-list>
                                </fieldset>
                            </v-col>
                            <v-col cols="12" md="6" sm="6">
                                <fieldset class="pa-4">
                                    <legend>Contabilidade</legend>
                                    <v-list dense>
                                        <div v-for="(contabilidade, index) in contabilidades" :key="index">
                                            <!-- <v-list-item :class="[{'blue lighten-5': contabilidade.selected }, 'white']"> -->
                                            <v-list-item>
                                                <v-list-item-action>
                                                    <v-checkbox v-model="contabilidade.selected" @change="onChangeItem(contabilidade)" :disabled="contabilidade.restrito"></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    {{contabilidade.nome}}
                                                </v-list-item-content>
                                            </v-list-item>
                                        </div>
                                    </v-list>
                                </fieldset>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="6" sm="6">
                                <fieldset class="pa-4">
                                    <legend>Relatórios</legend>
                                        <div v-for="(relatorio, index) in relatorios" :key="index">
                                            <!-- <v-list-item :class="[{'blue lighten-5': relatorio.selected }, 'white']"> -->
                                            <v-list-item>
                                                <v-list-item-action>
                                                    <v-checkbox v-model="relatorio.selected" @change="onChangeItem(relatorio)" :disabled="relatorio.restrito"></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    {{relatorio.nome}}
                                                </v-list-item-content>
                                            </v-list-item>
                                        </div>
                                </fieldset>
                            </v-col>
                            <v-col cols="12" md="6" sm="6">
                                <fieldset class="pa-4">
                                    <legend>Auxiliar</legend>
                                    <div v-for="(auxiliar, index) in auxiliares" :key="index">
                                        <!-- <v-list-item :class="[{'blue lighten-5': auxiliar.selected }, 'white']"> -->
                                        <v-list-item>
                                            <v-list-item-action>
                                                <v-checkbox v-model="auxiliar.selected" @change="onChangeItem(auxiliar)" :disabled="auxiliar.restrito"></v-checkbox>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                {{auxiliar.nome}}
                                            </v-list-item-content>
                                        </v-list-item>
                                    </div>
                                </fieldset>
                                <fieldset class="pa-4">
                                    <legend>Financiador</legend>
                                    <div v-for="(financiador, index) in financiadores" :key="index">
                                        <!-- <v-list-item :class="[{'blue lighten-5': financiador.selected }, 'white']"> -->
                                        <v-list-item>
                                            <v-list-item-action>
                                                <v-checkbox v-model="financiador.selected" @change="onChangeItem(financiador)" :disabled="financiador.restrito"></v-checkbox>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                {{financiador.nome}}
                                            </v-list-item-content>
                                        </v-list-item>
                                    </div>
                                </fieldset>
                            </v-col>
                        </v-row>

                    </v-tab-item>
                </v-tabs-items>

            </v-card-text>

        </v-card>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>

<script>
import UsuarioService from '../../../core/services/geral/UsuarioService';
import Usuario from '../../../core/domain/geral/Usuario';
import { PessoalService } from '../../../core/services/projetos';
import jiff from 'jiff';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function() {

            if ('form' in this.$refs)
                this.$refs.form.resetValidation();

            this.carregar();

            this.checkSelectedState();
        },
        value: function() {
            this.dialog = this.value;

            if(this.dialog){
                if(this.item.id == 0)
                    this.item.empresaId = this.sessionApp.empresaId;
                
                this.itemOriginal = jiff.clone(this.item);
            }

        },
        dialog: function() {
            if (!this.dialog) {
                this.$emit('fechou');
            }
        },
        lista: function(){
            
        }
    },
    created(){
        
    },
    data: () => ({
        service: new UsuarioService(),
        valid: true,
        dialog: false,
        isLoading: false,
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
        recursos: [],
        tabActive: null,
        observer: null,
        itemOriginal: null,
        projetos: [],
        doacoes: [],
        contasPagar:[],
        contasReceber:[],
        tesourarias:[],
        contabilidades:[],
        relatorios:[],
        auxiliares:[],
        financiadores:[],
        empresaPlano:'',
        foto: null,
        salvando: false,
    }),
    methods: {
        carregar(){
            this.sessionApp = JSON.parse(localStorage.sessionApp);
            this.empresaPlano = this.sessionApp.plano;
            
            this.projetos = [
                { id: 'CadBeneficiario', nome: 'Beneficiário', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'CadProjeto', nome: 'Cadastro de Projeto', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'CadRecursoPessoal', nome: 'Recurso Pessoal', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'CadTipoProjeto', nome: 'Tipos de Projeto', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'CadFrequencia', nome: 'Frequência', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'CadControleOcorrencia', nome: 'Controle de Ocorrências', selected: false, restrito: this.UsuarioRestrito(['G','B','E']) },
                { id: 'CadAvaliacaoBeneficiario', nome: 'Avaliação de Beneficiário', selected: false, restrito: this.UsuarioRestrito(['G','B','E']) }
            ]
            this.doacoes = [
                { id: 'CadDoador', nome: 'Doador', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'CadRelacionamento', nome: 'Relacionamento', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'CadOportunidade', nome: 'Oportunidade', selected: false, restrito: this.UsuarioRestrito(['G','B', 'P', 'O']) },
                { id: 'CadRegiao', nome: 'Região/Grupo', selected: false, restrito: this.UsuarioRestrito(['G','B']) }
            ]
            this.contasPagar = [
                { id: 'CadFornecedor', nome: 'Fornecedor', selected: false, restrito: this.UsuarioRestrito(['G']) },
                { id: 'CadCompromissos', nome: 'Documentos (Compromissos)', selected: false, restrito: this.UsuarioRestrito(['G']) },
                { id: 'QuitacaoCompromisso', nome: 'Quitação de Compromisso', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'LancamentoBancario1', nome: 'Lançamento Bancário', selected: false, restrito: this.UsuarioRestrito([]) }
            ]
            this.contasReceber = [
                { id: 'CadRecebiveis', nome: 'Documentos (Recebíveis)', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'BaixaRecebiveis', nome: 'Baixa Recebíveis', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'GeracaoRecebiveis', nome: 'Geração Recebíveis', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'EnvioBoletos', nome: 'Envio de Boletos / Nota Fiscal', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'LancamentoBancario2', nome: 'Lançamento Bancário', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'RetornoBancario', nome: 'Retorno Bancário', selected: false, restrito: this.UsuarioRestrito(['G','B','P','E']) }
            ]
            this.tesourarias = [
                { id: 'CadBanco', nome: 'Banco', selected: false, restrito: this.UsuarioRestrito(['G']) },
                { id: 'TransferenciaBancaria', nome: 'Transferência Bancária', selected: false, restrito: this.UsuarioRestrito(['G','B','E']) },
                { id: 'PlanoContasGerencial', nome: 'Plano de Contas (Gerencial)', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'LancamentoBancario3', nome: 'Lançamento Bancário', selected: false, restrito: this.UsuarioRestrito([]) },
            ]
            this.contabilidades = [
                { id: 'PlanoContasContabil', nome: 'Plano de Contas (Contábil)', selected: false, restrito: this.UsuarioRestrito(['G','B','P','E']) }
            ]
            this.relatorios = [
                { id: 'RelDoador', nome: 'Doador', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'RelBeneficiario', nome: 'Beneficiário', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'RelRecursoPessoal', nome: 'Recurso Pessoal', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'RelAcompanhamentoDoacoes', nome: 'Acompanhamento de Doações', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'RelReceitasDespesasProjetos', nome: 'Receitas e Despesas de Projetos', selected: false, restrito: this.UsuarioRestrito(['G','B','E']) },
                { id: 'RelProjetoDetalhado', nome: 'Projeto Detalhado', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'RelBalanceteFinanceiro', nome: 'Balancete Financeiro', selected: false, restrito: this.UsuarioRestrito(['G','B']) },
                { id: 'RelFluxoBancario', nome: 'Fluxo Bancário', selected: false, restrito: this.UsuarioRestrito(['G']) },
                { id: 'RelRecibo', nome: 'Recibo para Doador', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'RelLancamentoContabil', nome: 'Lançamento Contábil', selected: false, restrito: this.UsuarioRestrito(['G','B','P','E']) },
                { id: 'RelLog', nome: 'Log', selected: false, restrito: this.UsuarioRestrito([]) },
            ]
            this.auxiliares = [
                { id: 'CadEmpresa', nome: 'Organização', selected: false, restrito: this.UsuarioRestrito(['G','B','P','E']) },
                { id: 'CadUsuario', nome: 'Usuário', selected: false, restrito: this.UsuarioRestrito([]) },
                { id: 'Parametros', nome: 'Parâmetros', selected: false, restrito: this.UsuarioRestrito([]) }
            ]
            this.financiadores = [
                { id: 'RelProjetoDetalhado2', nome: 'Projeto Detalhado', selected: false, restrito: this.UsuarioRestrito([]) },
            ]
        },
        onChangeItem(menuItem){
            if(menuItem.selected){

                var object = {
                    
                    id: 0,
                    usuarioId: this.item.id,
                    empresaId: this.sessionApp.empresaId,
                    menu: menuItem.id,
                    
                };

                this.item.permissoes.push(object)
            }
            else{ 
                let index = this.item.permissoes.findIndex(x => x.menu == menuItem.id)
                // delete this.item.permissoes[index];
                this.item.permissoes.splice(index,1);
            }
        },
        checkSelectedState(){
            this.projetos.forEach(item =>{
                if( this.item.permissoes.find(x => x.menu == item.id) ){
                    item.selected = true;
                }
            });
            this.doacoes.forEach(item =>{
                if( this.item.permissoes.find(x => x.menu == item.id) ){
                    item.selected = true;
                }
            });
            this.contasPagar.forEach(item =>{
                if( this.item.permissoes.find(x => x.menu == item.id) ){
                    item.selected = true;
                }
            });
            this.contasReceber.forEach(item =>{
                if( this.item.permissoes.find(x => x.menu == item.id) ){
                    item.selected = true;
                }
            });
            this.tesourarias.forEach(item =>{
                if( this.item.permissoes.find(x => x.menu == item.id) ){
                    item.selected = true;
                }
            });
            this.contabilidades.forEach(item =>{
                if( this.item.permissoes.find(x => x.menu == item.id) ){
                    item.selected = true;
                }
            });
            this.relatorios.forEach(item =>{
                if( this.item.permissoes.find(x => x.menu == item.id) ){
                    item.selected = true;
                }
            });
            this.auxiliares.forEach(item =>{
                if( this.item.permissoes.find(x => x.menu == item.id) ){
                    item.selected = true;
                }
            });
            this.financiadores.forEach(item =>{
                if( this.item.permissoes.find(x => x.menu == item.id) ){
                    item.selected = true;
                }
            });
        },
        UsuarioRestrito(plano){
            if(plano.find(x => x == this.empresaPlano)){
                return true;
            }
            else{
                return false;
            }
        },
        save() {

            if (this.$refs.form.validate()) {

                this.salvando = true;
                
                let modelo = new Usuario(this.item);

                let patchModel = jiff.diff(this.itemOriginal, this.item, false);


                (this.item.id > 0 ? this.service.SalvarPatch(patchModel, this.item.id) : this.service.Salvar(modelo))
                .then(
                    res => {
                        this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                        this.$emit('salvou');
                        this.close();
                    }, 
                    err =>  {
                        this.$swal('Aviso', err.response.data.title ? err.response.data.title : err.response.data, err.response.status == 400 ? 'warning' : 'error');
                    }
                ).finally(() => {
                    this.salvando = false;
                })
            }

        },
        close() {
            this.reset();
            this.dialog = false;
        },
        reset(){
            this.projetos = [
            { id: 'CadBeneficiario', nome: 'Beneficiário', selected: false },
            { id: 'CadProjeto', nome: 'Cadastro de Projeto', selected: false },
            { id: 'CadRecursoPessoal', nome: 'Recurso Pessoal', selected: false },
            { id: 'CadTipoProjeto', nome: 'Tipos de Projeto', selected: false },
            { id: 'CadFrequencia', nome: 'Frequência', selected: false },
            { id: 'CadControleOcorrencia', nome: 'Controle de Ocorrências', selected: false },
            { id: 'CadAvaliacaoBeneficiario', nome: 'Avaliação de Beneficiário', selected: false }
            ],
            this.doacoes = [
                { id: 'CadDoador', nome: 'Doador', selected: false },
                { id: 'CadRelacionamento', nome: 'Relacionamento', selected: false },
                { id: 'CadOportunidade', nome: 'Oportunidade', selected: false },
                { id: 'CadRegiao', nome: 'Região/Grupo', selected: false }
            ],
            this.contasPagar = [
                { id: 'CadFornecedor', nome: 'Fornecedor', selected: false },
                { id: 'CadCompromissos', nome: 'Documentos (Compromissos)', selected: false },
                { id: 'QuitacaoCompromisso', nome: 'Quitação de Compromisso', selected: false },
                { id: 'LancamentoBancario1', nome: 'Lançamento Bancário', selected: false }
            ],
            this.contasReceber = [
                { id: 'CadRecebiveis', nome: 'Documentos (Recebíveis)', selected: false },
                { id: 'BaixaRecebiveis', nome: 'Baixa Recebíveis', selected: false },
                { id: 'GeracaoRecebiveis', nome: 'Geração Recebíveis', selected: false },
                { id: 'EnvioBoletos', nome: 'Envio de Boletos / Nota Fiscal', selected: false },
                { id: 'LancamentoBancario2', nome: 'Lançamento Bancário', selected: false },
                { id: 'RetornoBancario', nome: 'Retorno Bancário', selected: false }
            ],
            this.tesourarias = [
                { id: 'CadBanco', nome: 'Banco', selected: false },
                { id: 'TransferenciaBancaria', nome: 'Transferência Bancária', selected: false },
                { id: 'PlanoContasGerencial', nome: 'Plano de Contas (Gerencial)', selected: false },
                { id: 'LancamentoBancario3', nome: 'Lançamento Bancário', selected: false },
            ],
            this.contabilidades = [
                { id: 'PlanoContasContabil', nome: 'Plano de Contas (Contábil)', selected: false }
            ],
            this.relatorios = [
                { id: 'RelDoador', nome: 'Doador', selected: false },
                { id: 'RelBeneficiario', nome: 'Beneficiário', selected: false },
                { id: 'RelRecursoPessoal', nome: 'Recurso Pessoal', selected: false },
                { id: 'RelAcompanhamentoDoacoes', nome: 'Acompanhamento de Doações', selected: false },
                { id: 'RelReceitasDespesasProjetos', nome: 'Receitas e Despesas de Projetos', selected: false },
                { id: 'RelProjetoDetalhado', nome: 'Projeto Detalhado', selected: false },
                { id: 'RelBalanceteFinanceiro', nome: 'Balancete Financeiro', selected: false },
                { id: 'RelFluxoBancario', nome: 'Fluxo Bancário', selected: false },
                { id: 'RelRecibo', nome: 'Recibo para Doador', selected: false },
                { id: 'RelLancamentoContabil', nome: 'Lançamento Contábil', selected: false },
                { id: 'RelLog', nome: 'Log', selected: false },
            ],
            this.auxiliares = [
                { id: 'CadEmpresa', nome: 'Organização', selected: false },
                { id: 'CadUsuario', nome: 'Usuário', selected: false },
                { id: 'Parametros', nome: 'Parâmetros', selected: false }
            ],
            this.financiadores = [
                { id: 'RelProjetoDetalhado2', nome: 'Projeto Detalhado', selected: false },
            ]
        },
        async LoadImage(){

            if (!this.foto)
                return;
            
            let resizeImage = require('resize-image');
            const img = document.createElement('img');

            const promise = new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.readAsDataURL(this.foto);
                reader.onload = (event) => {
                    img.src = event.target.result;
                }
                img.onload = () => {
                    let data = resizeImage.resize(img, 140, 140, resizeImage.JPEG);
                    resolve(data)
                }
            });

            const response = await promise;
            this.item.foto = response.replace(/^[^,]*,/, "");
        },
        RemoveImage(){
            this.item.foto = null;
            this.foto = null;
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {
        const recursoPessoalService = new PessoalService();
        recursoPessoalService.ListarTudo().then(
            res=>{
                this.recursos = res.data.items;

                this.recursos.unshift({
                    id: null,
                    nome: 'Nenhum'
                })
            }
        )
    }
}
</script>
